import { useCallback, useMemo, useState } from 'react';

/**
 * Homebrew version of "useTransition" which is available in later react versions (17.0.2 does not have it)
 *
 * @todo remove when useTransition becomes available
 * @returns [isProcessing, startProcess]
 */
export default function useProcess(): [boolean, (fn: () => Promise<void>) => void] {
  const [process, setProcess] = useState<Promise<unknown>>();

  const startProcess = useCallback(
    (processFn: () => Promise<void>) => {
      void (async () => {
        if (process !== undefined) {
          await process;
        }

        setProcess(processFn().finally(() => setProcess(undefined)));
      })();
    },
    [process],
  );

  const isProcessing = useMemo(() => process !== undefined, [process]);

  return [isProcessing, startProcess];
}
